const MAX_RYBENA_MOBILE_WIDTH = 777;
const REGEX_ASTERISK = /\*\*(.*?)\*\*|\*([^*]+)\*/g;

export const isEmoji = (str) => {
  const emojiPattern =
    /^[\u{1F300}-\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{2300}-\u{23FF}\u{2B50}\u{23E9}-\u{23EC}\u{1F004}\u{1F0CF}\u{1F18E}\u{1F191}-\u{1F19A}\u{1F1E6}-\u{1F1FF}\u{1F201}-\u{1F251}\u{1F300}-\u{1F320}\u{1F321}-\u{1F32C}\u{1F32D}-\u{1F32F}\u{1F330}-\u{1F335}\u{1F336}\u{1F337}-\u{1F37C}\u{1F37D}-\u{1F393}\u{1F393}-\u{1F3B6}\u{1F3B7}-\u{1F3C1}\u{1F3C2}-\u{1F3F7}\u{1F3F8}-\u{1F43E}\u{1F43F}\u{1F440}\u{1F441}\u{1F442}-\u{1F4F7}\u{1F4F8}\u{1F4F9}-\u{1F4FC}\u{1F4FD}-\u{1F4FE}\u{1F4FF}\u{1F500}-\u{1F507}\u{1F508}-\u{1F50F}\u{1F510}\u{1F511}\u{1F512}\u{1F513}\u{1F514}\u{1F515}\u{1F516}\u{1F517}\u{1F518}\u{1F519}\u{1F51A}\u{1F51B}\u{1F51C}\u{1F51D}\u{1F51E}\u{1F51F}\u{1F520}\u{1F521}\u{1F522}\u{1F523}\u{1F524}\u{1F525}\u{1F526}\u{1F527}\u{1F528}\u{1F529}\u{1F52A}\u{1F52B}\u{1F52C}\u{1F52D}\u{1F52E}\u{1F52F}\u{1F530}-\u{1F567}\u{1F56F}\u{1F570}-\u{1F573}\u{1F574}-\u{1F575}\u{1F576}\u{1F577}-\u{1F579}\u{1F57A}-\u{1F587}\u{1F588}-\u{1F58F}\u{1F590}\u{1F591}\u{1F592}\u{1F593}\u{1F594}\u{1F595}\u{1F596}\u{1F597}\u{1F598}\u{1F599}\u{1F59A}\u{1F59B}\u{1F59C}\u{1F59D}\u{1F59E}\u{1F59F}\u{1F5A0}\u{1F5A1}\u{1F5A2}\u{1F5A3}\u{1F5A4}\u{1F5A5}\u{1F5A6}\u{1F5A7}\u{1F5A8}\u{1F5A9}\u{1F5AA}\u{1F5AB}\u{1F5AC}\u{1F5AD}\u{1F5AE}\u{1F5AF}\u{1F5B0}\u{1F5B1}\u{1F5B2}\u{1F5B3}\u{1F5B4}\u{1F5B5}\u{1F5B6}\u{1F5B7}\u{1F5B8}\u{1F5B9}\u{1F5BA}\u{1F5BB}\u{1F5BC}\u{1F5BD}\u{1F5BE}\u{1F5BF}\u{1F5C0}\u{1F5C1}\u{1F5C2}\u{1F5C3}\u{1F5C4}\u{1F5C5}\u{1F5C6}\u{1F5C7}\u{1F5C8}\u{1F5C9}\u{1F5CA}\u{1F5CB}\u{1F5CC}\u{1F5CD}\u{1F5CE}\u{1F5CF}\u{1F5D0}\u{1F5D1}\u{1F5D2}\u{1F5D3}\u{1F5D4}\u{1F5D5}\u{1F5D6}\u{1F5D7}\u{1F5D8}\u{1F5D9}\u{1F5DA}\u{1F5DB}\u{1F5DC}\u{1F5DD}\u{1F5DE}\u{1F5DF}\u{1F5E0}\u{1F5E1}\u{1F5E2}\u{1F5E3}\u{1F5E4}\u{1F5E5}\u{1F5E6}\u{1F5E7}\u{1F5E8}\u{1F5E9}-\u{1F5EE}\u{1F5EF}\u{1F5F0}\u{1F5F1}\u{1F5F2}\u{1F5F3}\u{1F5F4}\u{1F5F5}\u{1F5F6}\u{1F5F7}\u{1F5F8}\u{1F5F9}\u{1F5FA}\u{1F5FB}\u{1F5FC}\u{1F5FD}\u{1F5FE}\u{1F5FF}\u{1F600}-\u{1F64F}\u{1F650}-\u{1F67F}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1FB00}-\u{1FBFF}\u{1FC00}-\u{1FCFF}\u{1FD00}-\u{1FDFF}\u{1FE00}-\u{1FEFF}\u{1FF00}-\u{1FFFF}\u{20000}-\u{2FFFD}\u{30000}-\u{3FFFD}\u{40000}-\u{4FFFD}\u{50000}-\u{5FFFD}\u{60000}-\u{6FFFD}\u{70000}-\u{7FFFD}\u{80000}-\u{8FFFD}\u{90000}-\u{9FFFD}\u{A0000}-\u{AFFFD}\u{B0000}-\u{BFFFD}\u{C0000}-\u{CFFFD}\u{D0000}-\u{DFFFD}\u{E0000}-\u{EFFFD}]*$/gu;
  return emojiPattern.test(str);
};

export const importScriptRybena = (botData) => {
  try {
    if (botData && botData?.apiRybena) {
      const scriptApi = document.createElement('script');
      scriptApi.src = botData.apiRybena;
      scriptApi.async = true;
      scriptApi.defer = true;
      scriptApi.type = 'text/javascript';
      scriptApi.id = 'import-rybena-api';
      const hasRybenaApi = document.getElementById('import-rybena-api');
      if (!hasRybenaApi) {
        document.head.appendChild(scriptApi);
      }
    }
  } catch (error) {
    console.log('Error - importScriptRybena: ', error);
  }
};

export const hasRybenaToInitScript = () => {
  try {
    return !!(window?.RybenaDOM && window?.RybenaDOM?.getInstance());
  } catch (error) {
    console.log('Error - hasRybenaToInitScript: ', error);
    return false;
  }
};

export const hasRybena = () => {
  try {
    return !!(
      window?.RybenaDOM &&
      window?.RybenaApi &&
      window?.RybenaApi?.getInstance() &&
      window?.RybenaDOM?.getInstance()
    );
  } catch (error) {
    console.log('Error - hasRybena: ', error);
    return false;
  }
};

export const initScriptRybena = () => {
  if (hasRybenaToInitScript()) {
    try {
      window?.RybenaDOM?.getInstance()?.getRybenaScripts();
    } catch (error) {
      console.log('Error - initScriptRybena: ', error);
    }
  }
};

export const calcWidthAndHeightPage = (iframe, player) => {
  try {
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;
    const iframeWidth = iframe.offsetWidth;
    const iframeHeight = iframe.offsetHeight;
    const x = windowWidth - iframeWidth;
    const y = windowHeight - iframeHeight;
    player.style.position = 'fixed';
    player.style.height = '328px';
    player.style.minWidth = '182px';

    if (hasRybena() && x && y) {
      window?.RybenaApi?.getInstance()?.setCoordinates(x, y - 60);
    }
  } catch (error) {
    console.log('Error: ', error);
  }
};

export const changeStyleMobile = () => {
  try {
    const iframe = document.getElementById('rybena-iframe');
    if (iframe && iframe?.style) {
      const player = document.getElementById('rybena-player-div');
      if (hasRybena()) {
        if (
          player &&
          player?.style &&
          window.innerWidth < MAX_RYBENA_MOBILE_WIDTH
        ) {
          if (iframe && player) {
            calcWidthAndHeightPage(iframe, player);
          }
        }
      }
    }
  } catch (error) {
    console.log('Error - changeStyleMobile: ', error);
  }
};

export const loadedPlayer = () => {
  if (hasRybena()) {
    try {
      let loeaded = false;
      window?.RybenaApi?.getInstance()?.handleLoaded(() => {
        loeaded = true;
        changeStyleMobile();
      });
      return loeaded;
    } catch (error) {
      console.log('Error - loadedPlayer', error);
    }
  }
};

export const openPlayer = () => {
  if (hasRybena()) {
    try {
      window?.RybenaApi?.getInstance()?.openPlayer();
    } catch (error) {
      console.log('Error - openPlayer: ', error);
    }
  }
};

export const insertSuggestionListInMessage = (message) => {
  const infoMessage = `${message.message}. \nAgora vou traduzir os botões de sugestão.`;

  let suggestionListMessage = '';

  message.suggestionList.forEach((suggestion) => {
    suggestionListMessage += `. ${suggestion}\n`;
  });

  return infoMessage + suggestionListMessage;
};

export const replaceRegex = (message) => {
  const newPhrase = message?.replace(
    REGEX_ASTERISK,
    (match, group1, group2) => {
      if (group1 !== undefined) {
        return `**${group1}**`;
      }
      if (group2 !== undefined) {
        return group2;
      }
    }
  );

  return newPhrase;
};

export const translate = (message) => {
  if (hasRybena() && !!loadedPlayer()) {
    try {
      let finalMessage = message.message;
      if (message?.suggestionList && message?.suggestionList?.length) {
        finalMessage = insertSuggestionListInMessage(message);
      }

      if (isEmoji(finalMessage)) {
        finalMessage = 'emoji';
      }
      window?.RybenaApi?.getInstance()?.translate(replaceRegex(finalMessage));
    } catch (error) {
      console.log('Error - translate: ', error);
    }
  }
};

export const stopTranslate = () => {
  if (hasRybena()) {
    try {
      window?.RybenaApi?.getInstance()?.stop();
    } catch (error) {
      console.log('Error - stopTranslate: ', error);
    }
  }
};

let temp = 2;

export const finishedTranslate = (
  setHasTranslate,
  setInterruptMessage,
  setResetChat,
  setMessagesOnlyBot,
  changeTranslate
) => {
  if (hasRybena()) {
    try {
      window?.RybenaApi?.getInstance()?.handleTranslate(() => {
        temp += 1;
        if (
          !changeTranslate ||
          localStorage.getItem('TYPE_TRANSLATE') === null ||
          temp === 4
        ) {
          setHasTranslate(true);
          setInterruptMessage(false);
          setResetChat(false);
          setMessagesOnlyBot((prevMessages) => {
            if (!prevMessages.isTranslate && prevMessages.from === 'bot') {
              return {
                ...prevMessages,
                isTranslate: true,
              };
            }
            return prevMessages;
          });
        }

        localStorage.getItem('TYPE_TRANSLATE') === null;
      });
    } catch (error) {
      console.log('Error - finishTranslate: ', error);
    }
  }
};

export const filterMessagesWithoutTranslate = (messages) => {
  const messagesWithoutTranslate = messages.filter(
    (message) => !message.isTranslate
  );

  return messagesWithoutTranslate;
};

export const setLibrasToTranslate = () => {
  try {
    window?.RybenaApi?.getInstance()?.switchToLibras();
    openPlayer();
  } catch (error) {
    console.log('Error - setLibrasToTranslate: ', error);
  }
};

export const setVoiceToTranslate = () => {
  try {
    window?.RybenaApi?.getInstance()?.switchToVoz();
    openPlayer();
  } catch (error) {
    console.log('Error - setLibrasToTranslate: ', error);
  }
};

export const buildRestartPlayers = () => {
  try {
    const scriptApi = document.getElementById('import-rybena-api');
    const backupScript = scriptApi;
    document.head.removeChild(scriptApi);
    setTimeout(() => {
      document.head.appendChild(backupScript);
      openPlayer();
      const newMessag = 'Vamos tentar novamente';
      translate({ message: newMessag });
    }, 1000);
  } catch (error) {
    console.log('Error - buildRestartPlayers: ', error);
  }
};

export const closePlayer = (action, setHandleResetTranslate) => {
  if (hasRybena()) {
    try {
      window?.RybenaApi?.getInstance()?.closePlayer();

      if (action === 'restart') {
        buildRestartPlayers();
      }

      if (action === 'reset') {
        setTimeout(() => {
          openPlayer();
          setHandleResetTranslate(true);
        }, 3000);
      }
    } catch (error) {
      console.log('Error - openPlayer: ', error);
    }
  }
};

export const restartPlayer = () => {
  try {
    if (hasRybena() && loadedPlayer()) {
      closePlayer('restart');
    }
  } catch (error) {
    console.log('Error - restartPlayer: ', error);
  }
};
